import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
var __DEV__ = false;
export var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }

  _createClass(Logger, [{
    key: "info",
    value: function info(message) {
      if (__DEV__) {
        for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          optionalParams[_key - 1] = arguments[_key];
        }

        if (optionalParams.length > 0) {
          // tslint:disable-next-line:no-console
          console.info(message, optionalParams);
        } else {
          // tslint:disable-next-line:no-console
          console.info(message);
        }
      }
    }
  }, {
    key: "log",
    value: function log(message) {
      if (__DEV__) {
        for (var _len2 = arguments.length, optionalParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          optionalParams[_key2 - 1] = arguments[_key2];
        }

        if (optionalParams.length > 0) {
          // tslint:disable-next-line:no-console
          console.log(message, optionalParams);
        } else {
          // tslint:disable-next-line:no-console
          console.log(message);
        }
      }
    }
    /*
      Error method
    */

  }, {
    key: "error",
    value: function error(message) {
      if (__DEV__) {
        for (var _len3 = arguments.length, optionalParams = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          optionalParams[_key3 - 1] = arguments[_key3];
        }

        if (optionalParams.length > 0) {
          // tslint:disable-next-line:no-console
          console.error(message, optionalParams);
        } else {
          // tslint:disable-next-line:no-console
          console.error(message);
        }
      }
    }
  }, {
    key: "debug",
    value: function debug(message) {
      if (__DEV__) {
        for (var _len4 = arguments.length, optionalParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          optionalParams[_key4 - 1] = arguments[_key4];
        }

        if (optionalParams.length > 0) {
          // tslint:disable-next-line:no-console
          console.debug(message, optionalParams);
        } else {
          // tslint:disable-next-line:no-console
          console.debug(message);
        }
      }
    }
  }]);

  return Logger;
}();
var logger = new Logger();
export default logger;